import {Component} from '@angular/core';
import {NavController, NavParams, ViewController} from "ionic-angular";

@Component({
    selector: 'popover',
    templateUrl: 'popover.html'
})
export class PopoverComponent {

    items: any;

    constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController) {
        this.items = this.navParams.get('listData');
    }

    dismiss(item) {
        this.viewCtrl.dismiss(item);
    }

}



// WEBPACK FOOTER //
// ./src/components/popover/popover.ts